<div class="modal-header m-transparent">
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-header d-flex justify-content-center text-center">
  <h1 class="modal-title">{{'process-save.title' | translate}}</h1>
</div>

<div class="modal-body d-flex flex-column align-items-center border-bottom">
  <div>
    <span class="text-center font-weight-bold">{{"process-save.body"|translate}}</span>
    <span *ngIf="asmachta$|async" class="text-center font-weight-bold">{{asmachta$|async}}</span>
  </div>
  <div>
    <span class="text-center font-weight-bold">{{"process-save.body2"|translate}}</span>
  </div>

</div>
<div class="modal-body d-flex flex-column align-items-center">
  <div class="text-center">
    <div class="d-flex justify-content-around width-100 justify-content-around-mobile">
      <button class="app-button button-primary" (click)="activeModal.dismiss()">{{"process-save.btn-proceed"|translate}}</button>
      <button class="app-button button-secondery" (click)="exit()">{{"process-save.btn-exit"|translate}}</button>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/process-save-dialog/process-save-dialog.component.html